<template>
  <div id="app">
    <Head v-if="$route.meta.keepAlive"></Head>
    <router-view class="Inner-cnt" />
    <Foot v-if="$route.meta.keepAlive"></Foot>
  </div>
</template>

<script>
import Head from '@/components/Header.vue'
import Foot from '@/components/Footer.vue'
export default {
  name: 'App',
  components: {
    Foot,
    Head
  },
  data () {
    return {
      metaInfoAttr: {}
    }
  },
  metaInfo () {
    return {
      title: this.metaInfoAttr.title,
      meta: [
        {
          name: 'keywords',
          content: this.metaInfoAttr.keywords
        },
        {
          name: 'description',
          content: this.metaInfoAttr.description
        }
      ]
    }
  },
  watch: {
    $route: 'getRoute'
  },
  mounted () {
    this.getRoute()
  },
  methods: {
    getRoute () {
      // console.log(this.$route)
      var names = this.$route.name || '首页'
      this.$https
        .fetchPost('/api/getseo', {
          name: names
        })
        .then(res => {
          // console.log(res);
          if (res.data.data) {
            this.metaInfoAttr = res.data.data
          } else {
            this.metaInfoAttr = {
              description:
                '创建于1996年3月,一直致力于智能主食机械的研发、制造、营销和服务。公司从创立之初就肩负“为亿万家庭主食安全服务”的宗旨,以主食机械智能化发展战略来服务主食安全,研发和生产符合市场需求的产品,是国家级高新技术企业、解放军军用炊事机械军工企业,同时也是行业内率先进入资本市场的挂牌企业。',
              keywords: '馒头机,包子机,馒头生产线,揉面机,压面机,万杰,面条生产线,万杰智能',
              title: '万杰智能科技股份有限公司'
            }
          }
        })
    }
  }
}
</script>

<style>
@import '../static/base.css';
@import '../static/flex.less';

#app {
  background-color: rgba(246, 246, 246, 1);
}
.Inner-cnt {
  min-height: 70vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue